// The library filter behind a row's label and a bar's segment, kept apart from the card so it
// runs under Node's test runner. A case with its own `blunder` value
// (slipped, missed, lost on time, lost) lists exactly its games of that kind
// of ending; won is the period's wins of that kind (having a kind of ending
// means the game reached one); drawn has no filter that isolates it.
import type { EndingCase, EndingType, GameFilter } from '@chess/api-model';
import { endingCaseView } from '@chess/api-ending-case';

/** Every game of these kinds of ending: what a row's label opens ("Other" opens the rest together). */
export function rowFilter(types: readonly EndingType[]): GameFilter {
  return { endingType: types.length === 1 ? types[0] : [...types] };
}

export function segmentFilter(types: readonly EndingType[], c: EndingCase): GameFilter | undefined {
  const endingType = types.length === 1 ? types[0] : [...types];
  if (c === 'won') return { endingType, outcome: 'win' };
  const blunder = endingCaseView(c).filter;
  return blunder ? { endingType, blunder } : undefined;
}
